import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "../../App.styles";
import { environment, surveyUrl } from "../../utils";
import { Container } from "./ErrorMessage.styles";

interface ErrorMessageProps {
  title: string;
  description: string;
  testId?: string;
  hideSurveyLink?: boolean;
}

export const ErrorMessage: FC<PropsWithChildren<ErrorMessageProps>> = ({
  title,
  description,
  testId,
  hideSurveyLink,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <Container data-testid={testId}>
      {children}
      <h1>{title}</h1>
      <p>{description}</p>

      {!hideSurveyLink && environment.displayFeedback && (
        <Link href={surveyUrl} target="_blank">
          {t("survey_link_display")}
        </Link>
      )}
    </Container>
  );
};

export default ErrorMessage;
